import React from 'react'
import { BigSale } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { CustomLink, CustomTitle } from 'src/components'
import { getSupplierInvoice } from 'src/core/helpers'


const SaleSupplierInvoiceDocument: React.FC<{ sale: BigSale }> = ({ sale }) => {
  const { t } = useTranslation()

  return <>
    {sale.supplierInvoice ? 
      <>
        <CustomTitle label={t('Transactions.SupplierInvoice')} type={null} />
        <CustomLink
          label={t('Transactions.CheckSupplierInvoice')}
          link={getSupplierInvoice(sale)}
          isDisabled={false}
        /></> : 
      <></>}
  </>
}

export default SaleSupplierInvoiceDocument
